module.exports = __webpack_public_path__ + "img/solowin.a14fa534.png";